import { UserFaceRequest, UserFaceUpdate } from '@/api';

export function isUserFaceRequestWithThumbnail(item: any): item is UserFaceRequestWithThumbnail {
  return item.id === undefined && item.user !== undefined;
}
export type UserFaceRequestWithThumbnail = UserFaceRequest & { thumbnail?: string };

export type UserFaceObject = UserFaceRequestWithThumbnail | UserFaceUpdate;
